<template>
  <el-card v-loading="loading" class="project-task-list">
    <vxe-table
      keep-source
      :height="height"
      ref="taskListTableRef"
      class="task-list-table"
      :data="tableList"
      border="inner"
      :row-config="{ isCurrent: true, isHover: true }"
      :tree-config="{
        expandAll: true,
        transform: true,
        rowField: 'taskid',
        parentField: 'ptaskid',
        reserve: true,
        showIcon: true,
      }"
      :expand-config="{reserve:true}"
      :edit-config="{ trigger: 'manual', mode: 'cell', showIcon: false,beforeEditMethod:()=>{return true}}"
      @toggle-tree-expand="handleTreeExpand"
      @edit-actived="editActived"
    >
      <vxe-column v-if="config.seq" width="60" title="序号">
        <template #default="scope">
          <span>{{ ++scope._rowIndex }}</span>
        </template>
      </vxe-column>
      <vxe-column
        v-if="config.task_title"
        field="task_title"
        title="任务名称"
        min-width="200"
        :edit-render="{}"
        tree-node
        show-overflow="title"
        header-class-name="task-title-header"
      >
        <template #edit="scope">
          <el-input
            v-model="scope.row.task_title"
            autofocus
            :ref="`inputRef${scope.row._X_ROW_KEY}`"
            class="task-title-edit-class"
            placeholder="添加任务，按回车键(enter)保存"
            @input="$refs.taskListTableRef.updateStatus(scope)"
            @keyup.enter.native="handleEnterEvent(scope)"
            @blur="handleTaskTitleBlur(scope)"
          ></el-input>
        </template>
        <template #default="scope">
          <span class="flex justify-content-space-between">
            <span
              role="button"
              class="ellipsis pl-xs task-title-default-class"
              @click.stop="handleShowTaskDetail(scope)"
            >{{ scope.row.task_title }}</span>
            <span class="flex align-items-center">
              <span class="mr-sm" @click.stop="handleShowEditInput(scope)">
                <i class="el-icon-edit common-icon-hover"></i>
              </span>
              <el-dropdown
                trigger="click"
                placement="bottom"
                @command="handleAddTaskCommand(scope, $event)"
              >
                <i class="el-icon-plus text-bold mr-sm common-icon-hover"></i>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item command="current">添加同级任务</el-dropdown-item> -->
                  <el-dropdown-item command="child">添加子任务</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <CommonMore :list="commonConfig()" @change="handleCommonChange(scope.row, $event)" />
            </span>
          </span>
        </template>
      </vxe-column>

      <vxe-column
        v-if="config.status"
        field="status"
        title="状态"
        width="180"
        sortable
        :edit-render="{}"
      >
        <template #edit="scope">
          <StatusSelector
            :value="scope.row.status"
            :ref="`statusRef${scope._rowIndex}`"
            @change="handleStatusChange(scope, $event)"
          />
        </template>
        <template #default="scope">
          <div class="flex" role="button" @click="handleShowEditStatus(scope)">
            <span class="bd">
              <span v-if="scope.row.status == 50" class="common-tag level-2">进行中</span>
              <span v-else-if="scope.row.status == 100" class="common-tag level-3">已完成</span>
              <span v-else-if="scope.row.status == 0" class="common-tag level-1">打开</span>
              <span v-else-if="scope.row.status == -1" class="common-tag level-4">关闭</span>
            </span>
            <div class="ft flex-center">
              <i class="el-icon-arrow-down hover-show" />
            </div>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        field="principal"
        title="负责人"
        width="160"
        sortable
        :edit-render="{}"
        show-overflow="title"
      >
        <template #default="scope">
          <member-selector :uid="scope.row.principal" @change="handleManagerChange(scope, $event)">
            <div class="flex" role="button">
              <div class="bd">
                <div>
                  <span v-if="scope.row.principal" class="flex align-items-center">
                    <f-user-avatar
                      :user="{
                      uid:scope.row.principal,
                      avatar: scope.row.principal_avatar,
                      username: scope.row.principal_username,
                    }"
                      :preview="false"
                      size="mini"
                      role="button"
                    />
                    <span class="ml-xs ellipsis">
                      {{
                      scope.row.principal_username
                      }}
                    </span>
                  </span>

                  <span v-else>暂无负责人</span>
                </div>
              </div>
              <div class="ft flex-center">
                <i class="el-icon-user hover-show" />
              </div>
            </div>
          </member-selector>
        </template>
      </vxe-column>
      <vxe-column
        v-if="config.priority"
        field="priority"
        title="优先级"
        width="140"
        sortable
        :edit-render="{ autofocus: '.task-priority-edit-class' }"
      >
        <template #edit="scope">
          <PrioritySelector
            :value="scope.row.priority"
            :ref="`priorityRef${scope._rowIndex}`"
            class="task-status-edit-class"
            @change="handlePriorityChange(scope, $event)"
          />
        </template>
        <template #default="scope">
          <div role="button" @click="handleShowEditPriority(scope)">
            <span v-if="scope.row.priority == 1" class="priority-tag priority-1">最低</span>
            <span v-else-if="scope.row.priority == 2" class="priority-tag priority-2">较低</span>
            <span v-else-if="scope.row.priority == 3" class="priority-tag priority-3">普通</span>
            <span v-else-if="scope.row.priority == 4" class="priority-tag priority-4">较高</span>
            <span v-else-if="scope.row.priority == 5" class="priority-tag priority-5">最高</span>
            <span v-else-if="scope.row.priority == 0" class="priority-tag"></span>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        v-if="config.createtime"
        field="createtime"
        title="创建时间"
        width="150"
        sortable
        :edit-render="{}"
        align="center"
      >
        <template #default="scope">
          <span v-if="scope.row.createtime" class="task-time-default-class">
            {{ scope.row.createtime |
            parseTime("{y}-{m}-{d} {h}:{i}") }}
          </span>
        </template>
      </vxe-column>
      <vxe-column
        v-if="config.starttime"
        field="starttime"
        title="开始时间"
        width="160"
        sortable
        :edit-render="{}"
        align="center"
      >
        <template #edit="scope">
          <common-date-picker
            v-model="scope.row.starttime"
            :ref="`dateTimeRef${scope._rowIndex}`"
            type="date"
            format="yyyy-MM-dd"
            class="task-time-picker-calss"
            @change="handleEditDateTimeChange(scope, $event, 1)"
          ></common-date-picker>
        </template>
        <template #default="scope">
          <span role="button" @click="handleShowEditDateTime(scope)">
            <span v-if="scope.row.starttime" class="task-time-default-class">
              {{scope.row.starttime |
              parseTime("{y}-{m}-{d}") }}
            </span>
            <span v-else class="text-muted">请选择时间</span>
          </span>
        </template>
      </vxe-column>
      <vxe-column
        v-if="config.endtime"
        field="endtime"
        title="结束时间"
        width="160"
        sortable
        :edit-render="{}"
        align="center"
      >
        <template #edit="scope">
          <common-date-picker
            v-model="scope.row.endtime"
            :ref="`dateTimeRef${scope._rowIndex}`"
            type="date"
            format="yyyy-MM-dd"
            class="task-time-picker-calss"
            @change="handleEditDateTimeChange(scope, $event, 2)"
          ></common-date-picker>
        </template>
        <template #default="scope">
          <span role="button" @click="handleShowEditDateTime(scope)">
            <span v-if="scope.row.endtime" class="task-time-default-class">
              {{ scope.row.endtime |
              parseTime("{y}-{m}-{d}") }}
            </span>
            <span v-else class="text-muted">请选择时间</span>
          </span>
        </template>
      </vxe-column>

      <vxe-column v-if="config.other" title width="40">
        <template #default="scope">
          <i
            role="button"
            class="el-icon-location-information position-icon font-16"
            @click="getPosition(scope.row)"
          />
        </template>
      </vxe-column>

      <template #empty>
        <img class="image huger mt-lg" src="@/assets/empty.png" />
        <div class="font-md mb-hg">暂无数据</div>
      </template>
    </vxe-table>

    <div class="add-task pl-sm text-primary" @click="handleInsertTask(-1)">
      <i style="margin-top: 1px" class="el-icon-plus text-bold mr-xs"></i>
      <span>添加任务</span>
    </div>
  </el-card>
</template>

<script>
import { updateTaskApi, deleteTaskApi } from "@/api/pm/taskApi";
import { mapGetters } from "vuex";
import XEUtils from "xe-utils";
export default {
  components: {
    CommonMore: () => import("../common/CommonMore"),
    PrioritySelector: () => import("../common/CommonPrioritySelector"),
    StatusSelector: () => import("../common/CommonStatusSelector"),
    ManagerPullDown: () => import("./components/ManagerPullDown"),
    CommonDatePicker: () => import("../common/CommonTimePicker.vue"),
    MemberSelector: () => import("../common/MemberSelector"),
  },

  props: {
    config: {
      type: Object,
      default: () => {
        return {
          seq: true,
          task_title: true,
          manager: true,
          priority: true,
          starttime: true,
          endtime: true,
          createtime: true,
          status: true,
          other: false,
        };
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    projectid: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: String,
      default: "90%",
    },
  },

  data() {
    return {
      loading: false,
      priorityList: [
        {
          label: "最高",
          level: 5,
        },
        {
          label: "较高",
          level: 4,
        },
        {
          label: "普通",
          level: 3,
        },
        {
          label: "较低",
          level: 2,
        },
        {
          label: "最低",
          level: 1,
        },
      ],
      sexList: [],
      memberList: [],
      saveTask: false,
      task: {},
      rowCache: {},
    };
  },

  computed: {
    commonConfig() {
      return function () {
        return [
          {
            name: "删除任务",
            command: "delete",
            type: "danger",
          },
        ];
      };
    },
    tableList() {
      return this.$store.state.middleStore.taskList;
    },
  },

  watch: {
    tableList(val) {
      this.$nextTick(() => {
        this.$store.dispatch(
          "setGanttList",
          this.$refs.taskListTableRef.tableData
        );
      });
    },
  },

  created() {},

  methods: {
    /** 更多操作回调处理 */
    handleCommonChange(row, e) {
      if (e == "delete") {
        this.deleteTask(row);
      }
    },

    /** 编辑状态处理 */
    async handleShowEdit(scope) {
      await this.$refs.taskListTableRef.setEditCell(scope.row, scope.column);
    },
    handleShowEditInput(scope) {
      this.handleShowEdit(scope);
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs[`inputRef${scope.row._X_ROW_KEY}`].focus();
        });
      }, 50);
    },
    async handleShowEditDateTime(scope) {
      await this.handleShowEdit(scope);
    },
    async handleShowEditStatus(scope) {
      await this.handleShowEdit(scope);
      this.$nextTick(() => {
        this.$refs[`statusRef${scope._rowIndex}`] &&
          this.$refs[`statusRef${scope._rowIndex}`].togglePanel();
      });
    },

    handleShowEditPriority(scope) {
      this.handleShowEdit(scope);
      // setTimeout(() => {
      this.$nextTick(() => {
        this.$refs[`priorityRef${scope._rowIndex}`] &&
          this.$refs[`priorityRef${scope._rowIndex}`].togglePanel();
      });
      // }, 50)
    },
    handleClearActived() {
      this.$refs.taskListTableRef.clearActived();
    },
    handleShowTaskDetail(scope) {
      this.$taskDetail(scope.row.taskid);
    },

    getArr(array, index) {
      return array[index].children;
    },

    /** 任务处理 */
    updateTask(scope) {
      const $table = scope.$table;
      if (
        !($table.isUpdateByRow(scope.row) || $table.isInsertByRow(scope.row))
      ) {
        $table.updateStatus(scope);
        return;
      }

      let params = Object.assign({}, scope.row, {
        projectid: Number(this.projectid),
      });
      let row = scope.row;
      updateTaskApi(params).then(async (res) => {
        if (!res.errno) {
          row = Object.assign(row, res.data);
          await $table.reloadRow(row, {});
          console.log($table, $table.afterFullData);
          $table.updateData();
          this.$store.dispatch("setTaskdata", $table.afterFullData);
          $table.updateStatus(scope);
        } else {
          $table.revertData(scope, row);
          this.$message.error(res.message);
          if (!scope.row.taskid) $table.remove(scope.row);
        }
        // this.$emit('change')
      });
    },

    deleteTask(row) {
      this.$confirm(
        `确定要删除名为<span class="text-danger">【${row.task_title}】</span>任务么？ (若含有子任务将一并删除)`,
        "删除任务",
        {
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: "confirm-danger-class",
        }
      ).then(() => {
        deleteTaskApi({ taskid: row.taskid }).then((res) => {
          if (!res.errno) {
            let $table = this.$refs.taskListTableRef;
            $table.remove(row);
            console.log("删除后数据", $table.afterFullData);
            this.$store.dispatch("setTaskdata", $table.afterFullData);
            this.$message.success("删除成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    handleEnterEvent(scope) {
      this.saveTask = true;
      this.updateTask(scope);
      this.$refs[`inputRef${scope.row._X_ROW_KEY}`].blur();
    },

    async handleTaskTitleBlur(scope) {
      console.log(
        "[ scope.row.task_title ] >",
        scope.row.task_title,
        this.rowCache.task_title
      );
      const _this = this;
      const $table = this.$refs.taskListTableRef;

      if (_this.saveTask) {
        _this.saveTask = false;
      } else {
        if ($table.isInsertByRow(scope.row)) {
          await $table.remove(scope.row);
        }
        if (scope.row.task_title != _this.rowCache.task_title) {
          scope.row = Object.assign(scope.row, _this.rowCache);
        }

        $table.reloadRow(scope.row, {});
      }
      _this.handleClearActived();
    },

    handleStatusChange(scope, e) {
      if (e != undefined) {
        scope.row.status = e;
        this.$refs.taskListTableRef.updateStatus(scope);
        this.updateTask(scope);
      } else {
      }
    },

    handleManagerChange(scope, e) {
      if (e != undefined) {
        scope.row.principal = e.uid;
        scope.row.principal_username = e.username;
        scope.row.principal_avatar = e.avatar;
        this.$refs.taskListTableRef.updateStatus(scope);
        this.updateTask(scope);
      } else {
      }
    },

    handlePriorityChange(scope, e) {
      if (e != undefined) {
        scope.row.priority = e;
        this.$refs.taskListTableRef.updateStatus(scope);
        this.updateTask(scope);
      }
    },
    handleEditDateTimeChange(scope, e, l) {
      if (e != undefined) {
        if (l == 1) {
          scope.row.starttime = e;
        } else {
          scope.row.endtime = e;
        }
        this.$refs.taskListTableRef.updateStatus(scope);
        this.handleClearActived();
        this.updateTask(scope);
      } else {
        this.handleClearActived();
      }
    },

    handleAddTaskCommand(scope, commad) {
      this.handleInsertTask(scope, commad);
    },

    async handleInsertTask(scope, commad) {
      let before_taskid = 0;
      console.log("[ scope ] >", scope);
      if (scope != -1) {
        if (scope.row.children.length)
          before_taskid =
            scope.row.children[scope.row.children.length - 1].taskid;
      } else {
        let arr = this.$refs.taskListTableRef.afterTreeFullData;
        if (arr.length) before_taskid = arr[arr.length - 1].taskid;
      }

      const $table = this.$refs.taskListTableRef;
      const row = scope.row || scope;
      let task = {
        task_title: "",
        status: 0,
        projectid: Number(this.projectid),
        principal: null,
        priority: 0,
        starttime: null,
        endtime: null,
        createtime: parseInt(+new Date() / 1000),
        ptaskid:
          commad == "current"
            ? row.ptaskid
            : commad == "child"
            ? row.taskid
            : 0,
        before_taskid: before_taskid,
        remark: "", //校验有问题
      };

      const { row: newRow } = await $table.insertAt(
        task,
        commad == "child" ? -1 : row
      );
      await $table.reloadRow(newRow, {});
      commad == "child" && (await $table.setTreeExpand(scope.row, true));
      await $table.setEditCell(newRow, "task_title");
      let _this = this;
      this.$nextTick(() => {
        _this.$refs[`inputRef${newRow._X_ROW_KEY}`].focus();
      });
    },

    editActived(scope) {
      this.rowCache = XEUtils.clone(scope.row);
    },

    // 获取在甘特图中定位
    getPosition(row) {
      this.$emit("get-position", row);
    },

    //展开行触发事件 expanded, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event
    handleTreeExpand(obj) {
      setTimeout(() => {
        this.$store.dispatch("setGanttList", obj.$table.afterFullData);
      }, 300);
      this.$nextTick(() => {});
    },
  },
};
</script>

<style lang="scss">
.project-task-list {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  .el-card__body {
    height: 100%;

    .task-list-table {
      max-height: calc(100% - 40px);
      overflow-y: hidden;

      .vxe-body--row.row--current {
        background-color: #f5f7fa;

        .more {
          display: inline-block;
        }

        .common-icon-hover {
          display: inline-block;
        }
      }

      .vxe-body--row {
        .vxe-body--column {
          &:hover,
          &:focus,
          &.col--actived {
            background-color: rgba(52, 143, 228, 0.1);

            .hover-show {
              display: inline-block;
            }
          }
        }

        &:hover {
          .more {
            display: inline-block;
          }

          .common-icon-hover {
            display: inline-block;
          }

          .position-icon {
            display: inherit;
          }
        }

        .position-icon {
          display: none;
        }

        .task-title-edit-class {
          input {
            padding-left: 4px;
          }
        }

        .task-title-default-class {
          font-family: Arial;
        }

        // .task-time-picker-calss {
        // .el-input__inner {
        // padding-left: 33.3px;
        // }
        // }
        .task-time-default-class {
          width: 118px;
          display: inline-block;
          text-align: center;
          font-family: Arial;
        }

        .task-status-edit-class {
          width: 100%;
          // .el-input__inner {
          // padding-left: 30px;
          // }
        }

        // .task-priority-edit-class {
        // .el-input__inner {
        // padding-left: 31px;
        // }
        // }
      }

      .task-title-header {
        .vxe-cell {
          padding-left: 35px;
        }
      }
    }

    .add-task {
      cursor: pointer;
      height: 40px;
      z-index: 99;
      border-radius: 0 0 2px 2px;
      display: flex;
      align-items: center;
      user-select: none;

      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

.confirm-danger-class {
  border: 1px solid #f56c6c !important;
  background-color: #f56c6c !important;

  &:hover {
    border: 1px solid #f78989 !important;
    background-color: #f78989 !important;
  }
}
</style>